/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const BuchungsbestaetigungsversandartSammlung = ["KEINE", "NACHBESTELLUNG", "NACHBEZAHLUNG", "NACHBEARBEITUNG"] as const;

type Buchungsbestaetigungsversandart = typeof BuchungsbestaetigungsversandartSammlung[number];

export default Buchungsbestaetigungsversandart;